<div class="card v4-card">
  <p-toast class="p-toast-v4"></p-toast>
  <p-steps class="p-toast-v4" [model]="items" [readonly]="false" [activeIndex]="activeIndex"></p-steps>
</div>

<!-- Assign OU  -->
<div class="container-fluid p-0 d-flex justify-content-center">
  <div [hidden]="this.activeIndex != 0" class="mt-2 max-700">
    <div class="d-flex flex-wrap mt-2">
      <div *ngFor="let ou of selectedOus" class="ouBread">
        <div *ngIf="checkisImg(ou.data); else elseBlock" class="heading-imgg">
          <img src="{{ staticURL }}{{ ou.data }}" class="img-fluid p-1 tree-img-v4" />
        </div>
        <ng-template #elseBlock>
          <i class="{{ ou.data }} p-2" style="font-size: 1rem"></i>
        </ng-template>
        <span class="v4-color-white"> {{ ou.label }} </span>
      </div>
    </div>
    <h4 class="my-3">
      <i class="pi pi-check-square mx-2 v4-font-program"></i>{{ "Select OU for the Training Program" | translator }}
    </h4>
    <div class="d-flex justify-content-center" *ngIf="selectedOus">
      <p-tree [(selection)]="selectedOus" appendTo="body" selectionMode="multiple" [metaKeySelection]="false"
        class="w-md-20rem w-100 custom-tree" containerStyleClass="w-100" (onNodeSelect)="(null)"
        (selectionChange)="ouChanged($event)" filterPlaceholder="{{ 'Search filter' | translator }}"
        [value]="selectedTreeData" [filter]="true">
        <ng-template let-node pTemplate="default">
          <div class="d-flex" [ngClass]="
              this.selectedOus && this.selectedOus.includes(node)
                ? 'selectedNode'
                : ''
            ">
            <img *ngIf="checkisImg(node.data); else elseBlock" src="{{ staticURL }}{{ node.data }}"
              class="img-fluid p-1 tree-img-bg" style="max-height: 30px; max-width: 30px" />
            <ng-template #elseBlock>
              <i class="{{ node.data }} p-2" style="font-size: 1rem"></i>
            </ng-template>
            <b class="text-nowrap">{{ node.label }}</b>
          </div>
        </ng-template>
      </p-tree>
    </div>
    <div class="d-flex justify-content-end">
      <button class="v4-btn-every py-2 my-3" type="button" (click)="this.openProgramDetailForm()">
        {{ "Next" | translator }} <i class="pi pi-angle-left v4-ml-2"></i>
      </button>
    </div>
  </div>
</div>
<!-- end Assign OU -->

<!-- Detail Form  -->
<div class="container-fluid p-0 d-flex justify-content-center">
  <div [hidden]="this.activeIndex != 1" class="mt-2 max-700">
    <h4 class="my-3">
      <i class="pi pi-check-square mx-2 v4-font-program"></i>{{ "Enter Program Details" | translator }}
    </h4>
    <form class="grey-box" [formGroup]="trainingProgramForm">
      <div>
        <div class="row">
          <div class="col-lg-12 col-md-6 col-12 mb-3">
            <label class="label-ui mb-2" for="title"><i class="fa-solid fa-pen-nib mx-2"></i>{{ "Training Program Title"
              | translator }}&nbsp;:&nbsp;</label>
            <input type="text" id="title" placeholder="{{ 'Training program title' | translator }}" formControlName="title"
              pInputText class="w-100" />
            <div class="error" *ngIf="isFieldError('title')">
              <div>{{ "Training Program Title is required" | translator }}</div>
            </div>
          </div>

          <div class="col-lg-12 col-md-6 col-12 mb-3">
            <div class="program-d-column">
              <label class="label-ui mb-2" for="title">
                <i class="fa-solid fa-book mx-2"></i>
                {{ "ProgramDescription" | translator }}&nbsp;:&nbsp;</label>
              <textarea rows="5" cols="30" pInputTextarea id="description" formControlName="description"></textarea>
            </div>
            <div class="error" *ngIf="isFieldError('description')">
              <div>{{ "Description is required" | translator }}</div>
            </div>
          </div>
        </div>

        <!-- Internal External Starts here -->

        <div *ngIf="programType === '654e867bb9f4c5b8996191c5'" class="col-lg-12">
          <div class="mx-3">
            <label class="block v4-color-white font-medium mb-2 font-bold" for="description">
              {{ "Select Master Trainer" | translator }}
            </label>
            <h6>{{programData?.master_trainer?.name}}</h6>
            <div *ngIf="!(this.programData?.master_trainer?.name)" class="d-flex flex-row align-items-center justify-content-start w-100 gap-2">
              <div class="w-100">
                <p-dropdown styleClass="w-100" [options]="showInternal ? internalTrainers : externalTrainers"
                  optionLabel="name" formControlName="master_trainer" appendTo="body" [filter]="true" filterBy="name"
                  [showClear]="false" placeholder="{{ 'Choose the coach' | translator }}">
                  <ng-template let-trainers pTemplate="item">
                    <div class="flex align-items-center gap-2">
                      <div>{{ trainers.name }}</div>
                    </div>
                  </ng-template>
                </p-dropdown>
                <div class="error" *ngIf="isFieldError('master_trainer')">
                  <div>{{ "The trainer is required" | translator }}</div>
                </div>
              </div>
              <div class="d-flex w-100">
                <p-toggleButton class="v4-ptog-btn v4-ml-2" styleClass="w-100" onLabel="{{ 'External' | translator }}"
                  (onChange)="internalExternal($event)" offLabel="{{ 'Internal' | translator }}"></p-toggleButton>
                <div class="w-100" *ngIf="hasPermission('TRAINER', 'c')">
                  <button class="w-100 v4-btn-every py-2" (click)="addTrainerModal = true">
                    <i class="pi pi-plus v4-ml-2"></i>{{ "Add trainer" | translator }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Internal External ends here -->

        <div class="d-flex justify-content-end">
          <button class="v4-btn-every py-2 my-2" type="button" (click)="submitTrainingForm()">
            {{ "Next" | translator }}<i class="pi pi-angle-left v4-ml-2"></i>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
<!-- end Detail Form -->

<!-- Training Selection Form -->
<div [hidden]="this.activeIndex != 2" class="mt-2">
  <ng-container *ngIf="selectTrainings && !addNewTraining">
    <!-- <div class="container">
    <label class="filter-ui my-3">
      <h3 class="d-flex">
        <b class="d-flex align-items-end"
          ><i class="pi pi-filter v4-font-program"></ie
          ><span class="mx-2">{{ "filter" | translator }}</span>
          <i
            class="pi pi-angle-down"
            [ngClass]="
              true
                ? 'pi pi-angle-left filter-icon-size'
                : 'pi pi-angle-down filter-icon-size'
            "
          ></i>
        </b>
      </h3>
    </label>
  </div> -->

    <div class="container bg-rgb mb-3 p-0">
      <div class="flex-wrap my-2">
        <div class="d-flex justify-content-between col-bg mob-column">
          <div class="d-flex flex-wrap">
            <div>
              <h4 class="mb-0 px-2 mt-10">
                <b class="border-botom"><i class="pi pi-check-square v4-ml-2 v4-font-program"></i>{{ "Select Trainings"
                  | translator }}</b>
              </h4>
            </div>
          </div>
          <div class="mob-my-2">
            <button class="v4-btn-every py-2 m-2" (click)="getTrainings()">
              <i class="pi pi-search v4-ml-2"></i>{{ "Discuss" | translator }}
            </button>
            <button class="v4-btn-every py-2 m-2" (click)="refresh()">
              <i class="pi pi-refresh v4-ml-2"></i>{{ "Reset" | translator }}
            </button>
            <button class="v4-btn-every rgb-bg py-2 m-2" (click)="createTraining()">
              <i class="pi pi-plus v4-ml-2"></i>{{ "Create Training" | translator }}
            </button>
            <button class="v4-btn-every py-2 m-2" (click)="openConfirmation()">
              {{ "Next" | translator }} <i class="pi pi-angle-left v4-ml-2"></i>
            </button>
          </div>
        </div>
        <label class="border-botom">
          <h4>
            <b><i class="pi pi-filter mx-2 v4-font-program"></i>{{ "Training Filter" | translator }}</b>
          </h4>
        </label>
        <!-- Service Filter -->
        <div class="row d-flex my-2">
          <!-- <div class="col-md-4 col-12 my-1">
            <p-dropdown [options]="trainingTypes" [(ngModel)]="trainingFilter"
              placeholder="{{ 'Choose Type' | translator }}" [filter]="true" appendTo="body"
              styleClass="md:mb-0 sstarabic w-100" class="ppp-dropdown">
              <ng-template let-item pTemplate="item">
                <i [ngClass]="item.icon"></i>
                {{ item.arabic }}
              </ng-template>
            </p-dropdown>
          </div> -->

          <div class="col-md-12 col-12 my-1">
            <p-treeSelect class="v4-tree w-md-20rem w-100 ppp-tree-select" containerStyleClass="w-100"
              [(ngModel)]="oufilter" [options]="selectedTreeData" appendTo="body"
              placeholder="{{ 'Choose the organizational unit' | translator }}" [filter]="true"
              [filterInputAutoFocus]="true">
              <ng-template let-node pTemplate="default">
                <div class="d-flex">
                  <img *ngIf="checkisImg(node.data); else elseBlock" src="{{ staticURL }}{{ node.data }}"
                    class="img-fluid p-1 tree-img-bg" style="max-height: 30px; max-width: 30px" />
                  <ng-template #elseBlock>
                    <i class="{{ node.data }} p-2" style="font-size: 1rem"></i>
                  </ng-template>
                  <b class="text-nowrap">{{ node.label }}</b>
                </div>
              </ng-template>
            </p-treeSelect>
          </div>
          <div class="col-md-4 col-12 my-1"></div>
        </div>
        <!-- End Service Filter -->
      </div>
    </div>
    <div *ngIf="trainingData.length < 0 && trainingSpinner; else trainingBoard"
      class="users-data-table d-flex justify-content-center">
      <app-no-data [hidden]="trainingSpinner || trainingData.length > 0"></app-no-data>
    </div>
    <ng-template #trainingBoard>
      <div class="grey-box">
        <div style="direction: ltr" class="card v4-card">
          <!-- Splitter -->
          <ng-container style="direction: ltr" *ngIf="!trainingSpinner" trainingBoard>
            <ng-container *ngFor="let course of courses.controls">
              <div dir="rtl" class="d-flex align-items-center justify-content-between px-3 py-2 border rounded mb-2">
                <div class="d-flex gap-1 align-items-center" style="width: fit-content">
                  <div class="v4-icon-bg">
                    <img src="{{
                        course.value?.trainingId?.image
                          ? staticURL + course.value?.trainingId?.image
                          : '../../../assets/e-book.png'
                      }}" style="object-fit: contain; width: 100%; height: 100%" alt="loading..." />
                  </div>
                  <!-- <ng-template #elseBlock>
                    <i class="pi pi-plus-circle" style="font-size: 1rem"></i>
                  </ng-template> -->
                  <span style="font-size: 16px; color: white">{{
                    course.value?.trainingId?.title
                    }}</span>
                </div>
                <span class="d-flex align-items-center">
                  <!-- <span class="tabel-circle-btn" (click)="openCourse(course.value)">
                      <i pTooltip='{{"Edit"| translator}}'  tooltipPosition="top" class="pi pi-file-edit"></i>
                  </span> -->
                  <span class="tabel-circle-btn" (click)="removeCourse(course.value, true)">
                    <i pTooltip="{{ 'Delete' | translator }}" tooltipPosition="top" class="pi pi-times"></i>
                  </span>
                  <!-- <span class="tabel-circle-btn">
                      <i pTooltip='{{"Delete"| translator}}' tooltipPosition="top" class="pi pi-minus-circle"></i>
                  </span> -->
                  <!-- <span class="tabel-circle-btn">
                      <i pTooltip='{{"UnBlock Coordinator"| translator}}' tooltipPosition="top" class="pi pi-check"></i>
                  </span> -->
                </span>
              </div>
            </ng-container>
            <p-splitter class="v4-splitter" [panelSizes]="[50, 50]" [style]="{ minHeight: '350px' }">
              <ng-template pTemplate>
                <ng-container *ngIf="recreteSection.show; else trainingDetail">
                  <ng-container *ngIf="
                      recreteSection.recreateOptionFlag == true;
                      else recreate
                    ">
                    <div class="mx-2" style="direction: rtl">
                      <p class="f6b-p">
                        <i class="pi pi-exclamation-circle v4-ml-2 f-6-b"></i>{{
                        "The course selected is in progress please select form below options to recreate course"
                        | translator
                        }}
                      </p>
                      <div class="mb-3">
                        <div *ngFor="let category of recreateOptions" class="field-checkbox my-2 mx-2">
                          <p-radioButton [inputId]="category.key" name="category" [value]="category"
                            [(ngModel)]="recreteSection.selectedRecreateOption"></p-radioButton>
                          <label [for]="category.key" class="mx-2">{{
                            category.name
                            }}</label>
                        </div>
                      </div>
                      <button type="submit" [disabled]="
                          recreteSection.selectedRecreateOption == undefined
                        " (click)="chanegRecreateOptionFlag(true)" class="v4-btn-every py-2 w-100">
                        <i class="pi pi-check v4-ml-2"></i>{{ "Submit" | translator }}
                      </button>
                    </div>
                  </ng-container>
                  <ng-template #recreate>
                    <div style="direction: rtl">
                      <app-update-dates (updatedData)="addUpdatedCourse($event)" [courseId]="
                          recreteSection.courseId ? recreteSection.courseId : ''
                        "></app-update-dates>
                    </div>
                  </ng-template>
                </ng-container>
                <ng-template #trainingDetail>
                  <div *ngIf="!!trainingHolder; else noDataToshow" class="text-start p-3" style="direction: rtl">
                    <div class="d-flex flex-wrap justify-content-between align-items-center">
                      <h3>
                        <b class="border-botom"><i class="fa-solid fa-circle-info v4-ml-2"></i>{{ "Trainings Details" |
                          translator }}</b>
                      </h3>
                      <div class="program-flexx">
                        <div class="cust-flex">
                          <span class="btn-flex mx-1 my-2">
                            <span class="d-flex flex-column">
                              <span class="btn-css mx-2">{{
                                "Start Date" | translator
                                }}</span>
                              <span class="btn-css mx-2 font-0_8rem font-weight-200">
                                {{
                                trainingHolder?.trainingId?.start_date | date
                                }}
                              </span>
                            </span>
                            <span class="icon-box cccc">
                              <i class="pi pi-calendar-plus font-500"></i>
                            </span>
                          </span>
                        </div>
                        <div class="cust-flex">
                          <span class="btn-flex mx-1 my-2">
                            <span class="d-flex flex-column">
                              <span class="btn-css mx-2">{{
                                "End Date" | translator
                                }}</span>
                              <span class="btn-css mx-2 font-0_8rem font-weight-200">
                                {{
                                trainingHolder?.trainingId?.end_date | date
                                }}
                              </span>
                            </span>
                            <span class="icon-box cccc">
                              <i class="pi pi-calendar-minus font-500"></i>
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex align-items-center w-100 mb-2">
                      <div class="heading-img">
                        <img class="head-img" src="{{
                            trainingHolder?.trainingId?.image
                              ? staticURL + trainingHolder?.trainingId?.image
                              : '../../../assets/Rectangle-32.png'
                          }}" alt="loading..." />
                      </div>
                      <h3 class="font1-1">
                        {{ trainingHolder?.trainingId?.title }}
                      </h3>
                    </div>
                    <h6>{{ "Description" | translator }} :</h6>
                    <span [innerHTML]="
                        trainingHolder?.trainingId?.description | safeHTML
                      "></span>

                    <!-- Sessions list dot ui end  -->
                    <app-training-timeline [sessions]="trainingHolder?.trainingId?.sessions"></app-training-timeline>
                    <!--  Sessions list  dot ui end  -->

                    <hr />
                    <h4>
                      <i class="fa-solid fa-user-check v4-ml-2"></i>{{ "Users Completed training" | translator }}
                    </h4>
                    <p-table [value]="trainingUser" [paginator]="true" [showCurrentPageReport]="true" [rows]="5">
                      <ng-template pTemplate="header" let-columns>
                        <tr>
                          <th>{{ "user name" | translator }}</th>
                          <th>{{ "Email" | translator }}</th>
                          <th>{{ "Phone Number" }}</th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-user_t let-columns="columns">
                        <tr>
                          <td>
                            {{ user_t?.name?.first }}
                            {{ user_t?.name?.middle }} {{ user_t?.name?.last }}
                          </td>
                          <td>{{ user_t?.email }}</td>
                          <td>{{ user_t?.phone }}</td>
                        </tr>
                      </ng-template>
                    </p-table>
                    <hr />
                    <h4>
                      <i class="fa-solid fa-user-plus v4-ml-2"></i>{{
                      "Users that will added to the training" | translator
                      }}
                    </h4>
                    <p-table [value]="filteredTrainingProgramUser" [paginator]="true" [showCurrentPageReport]="true"
                      [rows]="5">
                      <ng-template pTemplate="header" let-columns>
                        <tr>
                          <th>{{ "user name" | translator }}</th>
                          <th>{{ "Email" | translator }}</th>
                          <th>{{ "Phone Number" }}</th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-user let-columns="columns">
                        <tr>
                          <td>
                            {{ user?.name?.first }} {{ user?.name?.middle }}
                            {{ user?.name?.last }}
                          </td>
                          <td>{{ user?.email }}</td>
                          <td>{{ user?.phone }}</td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                  <ng-template #noDataToshow>
                    <div class="users-data-table d-flex justify-content-center">
                      <app-no-data></app-no-data>
                    </div>
                  </ng-template>
                </ng-template>
              </ng-template>
              <ng-template pTemplate>
                <div class="col flex align-items-center justify-content-center">
                  <div [hidden]="trainingSpinner" style="direction: rtl"
                    class="col flex align-items-center justify-content-center p-3">
                    <div>
                      <h4 class="px-2 mt-10">
                        <b class="border-botom"><i class="fa-solid fa-person-chalkboard v4-ml-2"></i>{{ "Trainings" |
                          translator }}</b>
                      </h4>
                    </div>
                    <table>
                      <thead>
                        <tr class="mob-d-none">
                          <th scope="col"></th>
                          <th scope="col">{{ "the address" | translator }}</th>
                          <!-- <th scope="col">{{"Entities"| translator}}</th> -->
                          <!-- <th scope="col">{{ "Description" | translator }}</th> -->
                          <th scope="col">{{ "the month" | translator }}</th>
                          <th scope="col">{{ "Action" | translator }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let request of trainingData; let i = index" (click)="openTrainingPanel(request)"
                          [ngClass]="{
                            highlight: isCourseAdded(request),
                            'highlight-2':
                              trainingHolder?.trainingId?._id ==
                              request?.trainingId?._id
                          }">
                          <td style="
                              width: 100px !important;
                              background: transparent;
                            ">
                            <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                              <div class="d-flex tab-num-border-white">
                                <div class="tabel-detail-box">
                                  <div class="ms-tabel-num-box">
                                    {{ i + 1 }}
                                  </div>
                                </div>
                              </div>
                            </span>
                          </td>
                          <td data-label="Main Criteria">
                            <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                              <div class="tabel-detail-box">
                                <span class="tab-scroll">{{ request?.trainingId?.title }}
                                  &nbsp;&nbsp;
                                  <span *ngIf="request.recreationCount > 0">({{ "Iteration" | translator }}
                                    {{ request.recreationCount }})</span></span>
                              </div>
                            </span>
                          </td>

                          <td data-label="Factor">
                            <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                              <div class="tabel-detail-box">
                                <span class="tab-scroll">
                                  {{ request?.trainingId?.end_date | date }} -
                                  {{
                                  request?.trainingId?.start_date | date
                                  }}</span>
                              </div>
                            </span>
                          </td>
                          <td data-label="Options">
                            <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                              <div class="tabel-detail-box mob-height">
                                <div class="d-flex justify-content-between w-100 align-items-center">
                                  <div>
                                    <i *ngIf="!isCourseAdded(request)" pTooltip="{{
                                        'Add Training to Training Program'
                                          | translator
                                      }}" (click)="addCourse($event, request)" tooltipPosition="top"
                                      class="tabel-circle-btn pi pi-plus color-trash mr-4 p-text-secondary"
                                      style="font-size: 1.3rem"></i>
                                    <i *ngIf="isCourseAdded(request)" pTooltip="{{
                                        'Remove Training' | translator
                                      }}" (click)="removeCourse(request)" tooltipPosition="top"
                                      class="tabel-circle-btn pi pi-minus color-trash mr-4 p-text-secondary"
                                      style="font-size: 1.3rem"></i>
                                  </div>
                                </div>
                              </div>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="mb-5 flex justify-content-center">
                      <p-paginator [hidden]="totalTraining <= 0" (onPageChange)="onPageChange($event)" [first]="first"
                        [rows]="rows" [totalRecords]="totalTraining" [rowsPerPageOptions]="[10, 20, 30]"></p-paginator>
                    </div>
                  </div>
                </div>
              </ng-template>
            </p-splitter>
          </ng-container>
          <!-- End Splitter -->
        </div>
      </div>
    </ng-template>
    <div class="d-flex justify-content-center">
      <p-progressSpinner [hidden]="!trainingSpinner" styleClass="w-4rem h-4rem pb-4" strokeWidth="8"
        fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
    </div>
  </ng-container>

  <ng-container *ngIf="addNewTraining">
    <ng-container *ngIf="!!newTrainingType">
      <app-create-course *ngIf="!trainingPageData" [skillTypeId]="programType" [isSkillTraining]="isSkillTraining"
        [newBranchTraining]="!isSkillTraining" [master_trainer]="getMasterTrainer()" [openComponent]="true" [skillTypeId]="newTrainingType._id"
        [programOu]="selectedOus" [fromCreateTraining]="false" [formTrainingProgram]="true"
        (trainingCreated)="hideCreateTraining($event)"></app-create-course>

      <app-training-page *ngIf="!!trainingPageData" (closeTrainingPage)="closeTrainingPage($event)"
        [isInnerComponent]="trainingPageData"></app-training-page>
    </ng-container>
  </ng-container>
</div>
<!-- Training Selection Form -->

<!-- Confirmation Section -->
<div [hidden]="this.activeIndex != 3" class="mt-2">
  <div class="program-flex mt-3">
    <div>
      <h2>
        <i class="fa-solid fa-user-check v4-ml-2"></i>{{ "Confirmation Details" | translator }}
      </h2>
    </div>
    <div class="d-flex">
      <div class="cust-flex">
        <span class="btn-flex mx-1 my-2">
          <span class="d-flex flex-column">
            <span class="btn-css mx-2">{{ "Start Date" | translator }}</span>
            <span class="btn-css mx-2 font-0_8rem font-weight-200">
              {{ programStartDate | date }}
            </span>
          </span>
          <span class="icon-box cccc">
            <i class="pi pi-calendar-plus font-500"></i>
          </span>
        </span>
      </div>
      <div class="cust-flex">
        <span class="btn-flex mx-1 my-2">
          <span class="d-flex flex-column">
            <span class="btn-css mx-2">{{ "End Date" | translator }}</span>
            <span class="btn-css mx-2 font-0_8rem font-weight-200">
              {{ programEndDate | date }}
            </span>
          </span>
          <span class="icon-box cccc">
            <i class="pi pi-calendar-minus font-500"></i>
          </span>
        </span>
      </div>
    </div>
  </div>
  <div class="d-flex align-items-center w-100 mb-2">
    <!-- <div class="heading-img">
      <img
        class="head-img"
        src="../../../assets/Rectangle-32.png"
        alt="loading..."
      />
    </div> -->
    <h5 class="font1-3">
      {{ this.trainingProgramForm.get("title")?.value }}
    </h5>
  </div>
  <div class="mb-2">
    <h6 class="d-flex v4-ml-2">
      {{ "Description" | translator }} &nbsp; : &nbsp;
    </h6>
    <span> {{ this.trainingProgramForm.get("description")?.value }}</span>
  </div>
  <div class="d-flex flex-wrap">
    <div *ngFor="let ou of selectedOus" class="ouBread">
      <div *ngIf="checkisImg(ou.data); else elseBlock" class="heading-imgg">
        <img src="{{ staticURL }}{{ ou.data }}" class="img-fluid p-1 tree-img-v4" />
      </div>
      <ng-template #elseBlock>
        <i class="{{ ou.data }} p-2" style="font-size: 1rem"></i>
      </ng-template>
      <span class="v4-color-white"> {{ ou.label }} </span>
    </div>
  </div>
  <hr />

  <div>
    <h4 class="mb-3">
      <i class="pi pi-th-large v4-ml-2"></i>{{ "Selected Trainings" | translator }}
    </h4>

    <ng-container *ngFor="let course of courses.controls">
      <div class="d-flex align-items-center justify-content-between px-3 py-2 border rounded mb-2">
        <div class="d-flex gap-1 align-items-center" style="width: fit-content">
          <div class="v4-icon-bg">
            <img src="{{
                course.value?.trainingId?.image
                  ? staticURL + course.value?.trainingId?.image
                  : '../../../assets/e-book.png'
              }}" style="object-fit: contain; width: 100%; height: 100%" alt="loading..." />
          </div>
          <!-- <ng-template #elseBlock>
            <i class="pi pi-plus-circle" style="font-size: 1rem"></i>
          </ng-template> -->
          <span style="font-size: 16px; color: white">{{
            course.value?.trainingId?.title
            }}</span>
        </div>
        <span class="d-flex align-items-center">
          <!-- <span class="tabel-circle-btn" (click)="openCourse(course.value)">
              <i pTooltip='{{"Edit"| translator}}'  tooltipPosition="top" class="pi pi-file-edit"></i>
          </span> -->
          <span class="tabel-circle-btn" (click)="removeCourse(course.value, true)">
            <i pTooltip="{{ 'Delete' | translator }}" tooltipPosition="top" class="pi pi-times"></i>
          </span>
          <!-- <span class="tabel-circle-btn">
              <i pTooltip='{{"Delete"| translator}}' tooltipPosition="top" class="pi pi-minus-circle"></i>
          </span> -->
          <!-- <span class="tabel-circle-btn">
              <i pTooltip='{{"UnBlock Coordinator"| translator}}' tooltipPosition="top" class="pi pi-check"></i>
          </span> -->
        </span>
      </div>
    </ng-container>

    <!-- <div *ngFor="let ou of courses.controls" class="ouBread">
      <div>
        <img class="ou-img"
          src="{{ou.value.trainingId?.image ? staticURL+ou.value.trainingId?.image: '../../../assets/Rectangle-32.png'}}"
          alt="loading..." />

      </div>
      <span class="v4-color-white"> {{ou.value.trainingId?.title}} </span>
    </div> -->
  </div>
  <hr />
  <h4>
    <i class="fa-solid fa-user-check v4-ml-2"></i>{{ "Users added in training program" | translator }}
  </h4>
  <p-table [value]="trainingProgramUser" [paginator]="true" [showCurrentPageReport]="true" [rows]="5">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th>{{ "user name" | translator }}</th>
        <th>{{ "Email" | translator }}</th>
        <th>{{ "Phone Number" | translator }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-user let-columns="columns">
      <tr>
        <td>
          {{ user?.name?.first }} {{ user?.name?.middle }}
          {{ user?.name?.last }}
        </td>
        <td>{{ user?.email }}</td>
        <td>{{ user?.phone }}</td>
      </tr>
    </ng-template>
  </p-table>
  <div class="w-100 my-5">
    <p-progressSpinner *ngIf="submitSpinner"></p-progressSpinner>
    <button (click)="submitTrainingProgram(true)" class="v4-btn-every py-2 w-100">
      {{ "Submit" | translator }}
    </button>
  </div>
</div>

<!-- End Confirmation Section -->




<p-dialog [blockScroll]="true" [draggable]="false" header="{{ 'Add Trainer' | translator }}"
  [(visible)]="addTrainerModal" [style]="{ margin: '0rem 1rem', width: '70vw' }" [maximizable]="true">
  <ng-container *ngIf="!showInternal; else addInternalTrainer">
    <app-add-external-user *ngIf="addTrainerModal" [addCompany]="true" (updatedData)="handleUpdatedUserData($event)"
      [type]="'CREATE'" [ExternalType]="'trainer'"></app-add-external-user>
  </ng-container>
  <ng-template #addInternalTrainer>
    <app-assign-users [userFetchUrl]="'user/get'" [selectionData]="[]" (selectedUsersList)="assNewTrainers($event)"
      [query]="{
      'externalUser.status': { $ne: true },
      'externalUser.role': { $nin: ['trainer', 'coordinator'] }
    }" *ngIf="showInternal">
    </app-assign-users>
  </ng-template>
</p-dialog>